import React from 'react';
import PropTypes from 'prop-types';
import Button from '../Buttons/Button';
import Icon from '../Icons/Icon';

const DropdownButton = ({ onClick, label, noArrow, iconFill, classes }) => {
  let dropdownBtnInner;
  if (label) {
    dropdownBtnInner = (
      <div className="dropdown-btn__label">
        <span>{label}</span>
        {noArrow === undefined &&
          <Icon name="drop-down" classes="dropdown-btn__icon" fill={iconFill} />
        }
      </div>
    );
  } else if (noArrow === undefined) {
    dropdownBtnInner = <Icon name="drop-down" classes="dropdown-btn__icon" fill={iconFill} />;
  }

  return <Button onClick={onClick} classes={`dropdown-btn ${classes}`} faux>{dropdownBtnInner}</Button>;
};

DropdownButton.propTypes = {
  onClick: PropTypes.func,
  label: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  noArrow: PropTypes.bool,
  iconFill: PropTypes.string,
  classes: PropTypes.string,
};

export default DropdownButton;



// WEBPACK FOOTER //
// ./library/app/components/Global/Dropdowns/DropdownButton.js